import styled, { css } from 'styled-components';

interface ContainerProps {
  $selectedBubbleColor?: string;
  disabled?: boolean;
  $unclickable?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  button {
    position: relative;
    border: 0;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    cursor: ${({ $unclickable }) => ($unclickable ? 'not-allowed' : 'pointer')};
    background-color: ${({ $selectedBubbleColor, theme }) =>
      $selectedBubbleColor || theme.flag.indisponivel};
    transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
    &:hover {
      opacity: 0.8;
      transform: scale(1.2);
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      button {
        background-color: ${({ theme }) => theme.flag.indisponivel};
        cursor: not-allowed;

        &:hover {
          opacity: 1;
          transform: scale(1);
        }
      }
    `}
`;

export const MenuList = styled.ul`
  position: absolute;
  z-index: 1000 !important;
  min-width: 8rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.875rem;
  text-align: left;
  /* list-style: none; */
  border-radius: 4px;
  background-color: #fff;
  background-clip: padding - box;
  border: 0 solid rgba(34, 42, 66, 0.15);
  box-shadow: 0 1px 2px rgba(50, 50, 93, 0.1),
    0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
  user-select: none;
  top: 2.5rem;
  left: -1rem;

  &::before {
    display: inline-block;
    position: absolute;
    width: 0;
    height: 0;
    vertical-align: middle;
    content: '';
    top: -5px;
    left: 1.2rem;
    color: #fff;
    border-bottom: 0.4em solid;
    border-right: 0.4em solid transparent;
    border-left: 0.4em solid transparent;
  }
`;

interface ItemProps {
  $bubbleColor: string;
}
export const Item = styled.li<ItemProps>`
  padding: 0.25rem 0.5rem;
  list-style: none;

  div {
    background: none;
    justify-content: flex-start !important;
    border: none;
    width: 100%;
    text-align: left;
    display: flex;
    align-items: center;
    font-size: 0.75rem;
    padding: 0.6rem 0.25rem 0.6rem 0.5rem;
    cursor: pointer;

    -webkit-transition: all 0.15s linear;
    transition: all 0.15s linear;
    text-transform: uppercase;
    span {
      display: flex;
      color: ${props => props.theme.menu.fontColor} !important;

      &:before {
        content: '';

        width: 1rem;
        height: 1rem;
        margin-right: 0.4rem;
        background-color: ${props => props.$bubbleColor};
        border-radius: 50%;
      }
    }
    &:hover {
      background-color: hsla(0, 0%, 87.1%, 0.3);
    }

    svg {
      margin-right: 1rem;
    }
  }
`;
